import { cn } from '@/lib/utils';

export type BadgeTone =
  | 'neutral'
  | 'brand'
  | 'accent'
  | 'ok'
  | 'warn'
  | 'danger'
  | 'info'
  | 'outline';

const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-sunken text-ink-2 border-line',
  brand: 'bg-brand-soft text-brand border-brand-line',
  // Gold: „hier wartet Arbeit“ – offene Gesichter, fehlende Belege, unklare
  // Daten. Der einzige Akzent der Oberfläche, deshalb sparsam einsetzen.
  accent: 'bg-accent-soft text-accent-strong border-transparent font-semibold',
  ok: 'bg-ok-soft text-ok border-transparent',
  warn: 'bg-warn-soft text-warn border-transparent',
  danger: 'bg-danger-soft text-danger border-transparent',
  info: 'bg-info-soft text-info border-transparent',
  outline: 'bg-transparent text-ink-2 border-line-strong',
};

export function Badge({
  tone = 'neutral',
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { tone?: BadgeTone }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-0.5',
        'text-[11.5px] leading-4 font-medium whitespace-nowrap',
        TONES[tone],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}

/** Kleiner farbiger Punkt – trägt Identität neben Text, statt Text zu färben. */
export function Dot({ className }: { className?: string }) {
  return <span aria-hidden className={cn('size-2 shrink-0 rounded-full', className)} />;
}
